import styled, { createGlobalStyle } from "styled-components";

export const Container = styled.div`
  height: ${({ theme }) => theme.baseHeaderHeight};
  width: 100%;
  background: ${props => props.theme.backgroundDark};
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px;
  z-index: ${({ theme }) => theme.zIndex.sidebar + 1};
  position: fixed;
  top: 0px;

  @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
    margin: 0 auto;
    padding: 15px 10px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 30px 60px;
    height: ${({ theme }) => theme.headerTablePlusHeight};
  }

  .drawer-container {
    width: 279px;
    position: fixed;
    right: 0;
    top: 72px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
      top: 96px;
    }
  }

  .admin-content {
    display: flex;
    margin-left: 34px;

    .nav-item {
      margin-right: 34px;
      color: ${props => props.theme.textDark};
      font-size: ${props => props.theme.p1b.fs};
      font-family: ${props => props.theme.p1r.ff};
      letter-spacing: 0.5px;
    }
  }

  .search-icon {
    margin-right: 24px;
  }
`;

export const TeamName = styled.div`
  background: ${props => props.color};
  padding: 0px 21px 0px 25px;
  width: 100%;
  height: 24px;
  border-radius: 33px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .team-title {
    font-family: ${props => props.theme.p2b.ff};
    font-size: ${props => props.theme.p2b.fs};
    color: ${props => props.theme.textLight};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
export const Inner = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;

  .always-align-top {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 20px;
    width: inherit;
    margin-top: ${({ customLogo }) => (customLogo ? "0" : "6px")};
  }

  .nav-items {
    max-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 801px) {
      margin-left: -100px;
    }
  }

  .logo-container,
  .header-container {
    margin-right: 75px;
    width: 146px;
    flex-shrink: 0;
  }

  .header-container {
    height: auto;
    display: flex;
    flex-direction: column;
    justify-items: center;

    .blue-dot-title {
      width: 100%;
      justify-self: center;
    }

    .text {
      text-align: center;
      color: ${props => props.theme.textDark};
      margin-top: 2px;
    }
  }
`;

export const Logo = styled.img`
  cursor: pointer;
  min-width: 100px;

  @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
    min-width: 110px;
  }
`;

export const Cart = styled.div`
  position: relative;
`;

export const Counter = styled.div`
  position: absolute;
  right: -3px;
  top: 2px;
  background: ${props => props.theme.highlightDark};
  width: 21px;
  height: 21px;
  font-size: ${props => props.theme.p2b.fs};
  font-family: ${props => props.theme.p2b.ff};
  line-height: ${props => props.theme.lineHeight.lg};
  text-align: center;
  border-radius: 50%;

  p {
    margin-top: 3.5px;
    margin-left: -2px;
  }
`;

export const SearchContainer = styled.div`
  flex-grow: 6;
  flex-shrink: 1;
  min-width: 0;
  margin-left: 8px;
  display: flex;
  align-items: flex-start;

  @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
    margin-left: 27px;
  }

  @media (max-width: 750px) {
    display: none;
  }
`;

export const MobileView = styled.div`
  display: grid;
  grid-auto-columns: auto 1fr;
  grid-auto-flow: column;
  width: 100%;
  align-items: center;

  .mobile-items {
    justify-self: end;
    margin-right: 12px;
  }
`;

// Applied-filters strip: a fixed single-row marquee below the mobile header.
export const MobileFilterBar = styled.div`
  position: fixed;
  top: ${({ theme }) => theme.baseHeaderHeight};
  left: 0;
  right: 0;
  z-index: ${({ theme }) => theme.zIndex.sidebar};
  display: flex;
  align-items: flex-start;

  // box fills the full width; expanded state overlays content below
  & > div {
    width: 100%;
  }
`;

// Reserves vertical space for the strip so it pushes content and the filter
// drawer down instead of overlaying them. Mounted only while the strip shows.
export const MobileFilterBarSpace = createGlobalStyle`
  :root {
    --mobile-filter-bar-height: ${({ theme }) => theme.mobileFilterBarHeight};
  }
`;
